import { isNone } from '@ember/utils';
import { InAppPreview } from '../previews';

const hasErrors = (key: string[] | null) => !isNone(key) && key.length > 0;

export function hasInAppPreviewErrors(preview: InAppPreview | null) {
  if (isNone(preview)) {
    return false;
  }
  let { to, body_json, body_html } = preview.errors;
  return hasErrors(to) || hasErrors(body_json) || hasErrors(body_html);
}
